module.exports = __webpack_public_path__ + "img/pr-2.8f2f9adc.png";